import { colors } from 'global-styles';

const { teal, DeYork, yellow, SunGlo, BlueViolet } = colors;

const ordered = [teal, DeYork, yellow, SunGlo, BlueViolet];

export default ordered;
